import React, { useState, useEffect, useCallback } from "react";
import {
  Layout,
  Button,
  Card,
  Tag,
  Row,
  Col,
  Spin,
  Input,
  List,
  Typography,
  notification,
  Alert,
} from "antd";
import { useNavigate } from "react-router-dom";
import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
// import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import TenantApi from "../../common/Apis/TenantApi";
import WhiteListedIPs from "../../common/CommonUI/WhiteListedIPs";
import SubtenantApi from "../../common/Apis/SubtenantApi";

const { Text } = Typography;

const SubscriptionInfo = () => {
  const { Content } = Layout;
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [companyData, setCompanyData] = useState(null);
  const [ipList, setIpList] = useState([]);
  const [newIp, setNewIp] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [apiError, setApiError] = useState(""); // <-- new state for API errors
  const [isValidInput, setIsValidInput] = useState(false);
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

  const getCompanyInfo = useCallback(() => {
    setIsLoading(true);
    if (decodedToken?.roles[0] === "TENANT_ADMIN") {
      TenantApi.Singletenants()
        .then((res) => {
          setCompanyData(res.payload);
          var temp = new Array();
          temp = res.payload.whitelistedIps ? res.payload.whitelistedIps.split(",") : [];
          setIpList(temp || []);
          console.log(res.payload.whitelistedIps);
        })
        .catch((err) => console.error(err))
        .finally(() => setIsLoading(false));
    } else {
      SubtenantApi.SingleSubtenantsApi()
        .then((res) => {
          setCompanyData(res.payload);
          var temp = new Array();
          temp = res.payload?.whitelistedIps ? res.payload.whitelistedIps.split(",") : [];
          setIpList(temp || []);
          console.log(res.payload.whitelistedIps);
        })
        .catch((err) => console.error(err))
        .finally(() => setIsLoading(false));
    }
  }, []);

  useEffect(() => {
    getCompanyInfo();
  }, [getCompanyInfo]);

  // const handleMakePayment = () => {
  //   navigate("/payment");
  // };

  // Validate single IPv4
  const isValidIp = (ip) => {
    const ipRegex =
      /^(25[0-5]|2[0-4]\d|[01]?\d{1,2})(\.(25[0-5]|2[0-4]\d|[01]?\d{1,2})){3}$/;
    return ipRegex.test(ip.trim());
  };

  // Validate CIDR: e.g., 203.0.113.0/24
  const isValidCidr = (cidr) => {
    const cidrRegex =
      /^(25[0-5]|2[0-4]\d|[01]?\d{1,2})(\.(25[0-5]|2[0-4]\d|[01]?\d{1,2})){3}\/([0-9]|[1-2][0-9]|3[0-2])$/;
    return cidrRegex.test(cidr.trim());
  };

  // Update validation whenever input changes
  const handleInputChange = (value) => {
    setNewIp(value);
    if (!value.trim()) {
      setErrorMessage("Please enter an IP or CIDR range.");
      setIsValidInput(false);
    } else if (!isValidIp(value) && !isValidCidr(value)) {
      setErrorMessage("Invalid IP or CIDR format.");
      setIsValidInput(false);
    } else if (ipList.includes(value.trim())) {
      setErrorMessage("This IP/CIDR is already added.");
      setIsValidInput(false);
    } else {
      setErrorMessage("");
      setIsValidInput(true);
    }
  };

  const handleAddIp = () => {
    if (!isValidInput) return;
    setIpList([...ipList, newIp.trim()]);
    setNewIp("");
    setIsValidInput(false);
    setApiError(""); // Clear API error when adding new IP
  };

  const handleRemoveIp = (ip) => {
    const currentIpList = Array.isArray(ipList)
      ? ipList
      : typeof ipList === "string"
        ? ipList.split(",").map((item) => item.trim()).filter(Boolean)
        : [];

    setIpList(currentIpList.filter((item) => item !== ip));
    setIsValidInput(false);
    setApiError("");
  };

  const handleSubmitIps = () => {
    if (ipList.length === 0) {
      setErrorMessage("Add at least one IP or CIDR range to submit.");
      return;
    }

    const ipsString = ipList.join(","); // Create comma-separated string

    if (decodedToken?.roles[0] === "TENANT_ADMIN") {
      TenantApi.AddWhiteListedIPs({ whitelistedIps: ipsString })
        .then(() => {
          setErrorMessage("");
          setApiError("");
          setNewIp("");
          setIsValidInput(false);

          // Success notification
          notification.open({
            message: (
              <span style={{ fontWeight: "bold" }}>
                White-listed IPs updated successfully!
              </span>
            ),
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#b3ffb3",
              color: "green",
            },
          });

          // Refresh company data and IP list
          getCompanyInfo();
        })
        .catch((err) => {
          console.error(err);
          setApiError(err?.message || "Failed to update IPs.");
        });
    } else {
      SubtenantApi.AddWhiteListedIPs({ whitelistedIps: ipsString, tenantDTO: { id: decodedToken?.tenantId } })
        .then(() => {
          setErrorMessage("");
          setApiError("");
          setNewIp("");
          setIsValidInput(false);

          // Success notification
          notification.open({
            message: (
              <span style={{ fontWeight: "bold" }}>
                White-listed IPs updated successfully!
              </span>
            ),
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#b3ffb3",
              color: "green",
            },
          });

          // Refresh company data and IP list
          getCompanyInfo();
        })
        .catch((err) => {
          console.error(err);
          setApiError(err?.message || "Failed to update IPs.");
        });
    }

  };


  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />
        <Content
          style={{
            margin: "14px 16px 0",
            padding: "30px",
            background: "white",
          }}
        >
          <h2 style={{ marginBottom: "20px" }} className="BreadcrumbTitle">
            {decodedToken?.roles[0] === "TENANT_ADMIN" ? "Company Details" : "Store Details"}
          </h2>

          {isLoading ? (
            <Spin size="large" />
          ) : companyData ? (
            <Card
              style={{ maxWidth: "600px", margin: "0 auto", borderRadius: "10px" }}
              bodyStyle={{ fontSize: "16px", lineHeight: "28px" }}
            >
              <Row gutter={[0, 16]}>
                <Col span={10} style={{ fontWeight: "bold" }}>
                  {decodedToken?.roles[0] === "TENANT_ADMIN" ? "Company Code:" : "Store Code:"}
                </Col>
                <Col span={14}>{decodedToken?.roles[0] === "TENANT_ADMIN" ? companyData.tenantCode : companyData.subTenantCode}</Col>

                <Col span={10} style={{ fontWeight: "bold" }}>
                  {decodedToken?.roles[0] === "TENANT_ADMIN" ? "Company Name:" : "Store Name:"}
                </Col>
                <Col span={14}>{decodedToken?.roles[0] === "TENANT_ADMIN" ? companyData.tenantName : companyData.subTenantName}</Col>

                {decodedToken?.roles[0] === "TENANT_ADMIN" && (
                  <Col span={10} style={{ fontWeight: "bold" }}>
                    Subscription Plan:
                  </Col>
                )}
                {decodedToken?.roles[0] === "TENANT_ADMIN" && (
                  <Col span={14}>{companyData.billingCycle}</Col>
                )}

                {decodedToken?.roles[0] === "TENANT_ADMIN" && (
                  <Col span={10} style={{ fontWeight: "bold" }}>
                    Current Status:
                  </Col>
                )}
                {decodedToken?.roles[0] === "TENANT_ADMIN" && (
                  <Col span={14}>
                    {companyData.paymentStatus === "TRIAL" && <Tag color="blue">TRIAL</Tag>}
                    {companyData.paymentStatus === "PAID" && <Tag color="blue">PAID</Tag>}
                    {companyData.paymentStatus === "OVERDUE" && <Tag color="cyan">OVERDUE</Tag>}
                    {companyData.paymentStatus === "WARNING" && <Tag color="orange">WARNING</Tag>}
                    {companyData.paymentStatus === "SUSPENDED" && <Tag color="red">SUSPENDED</Tag>}
                  </Col>
                )}

                {/* White-listed IPs */}
                <Col span={24} style={{ fontWeight: "bold", marginTop: "10px" }}>
                  White-listed IP Addresses / CIDR Ranges:
                </Col>
                <Col span={24}>
                  {/* <WhiteListedIPs  /> */}
                </Col>
                   
                <Col span={24}>
                  <List
                    bordered
                    dataSource={ipList}
                    renderItem={(ip) => (
                      <List.Item
                        actions={[
                          <Button danger size="small" onClick={() => handleRemoveIp(ip)}>
                            Remove
                          </Button>,
                        ]}
                      >
                        {ip}
                      </List.Item>
                    )}
                    style={{ marginBottom: "10px" }}
                  />

                  <div style={{ display: "flex", gap: "10px" }}>
                    <Input
                      placeholder="Enter single IP or CIDR (e.g., 203.0.113.0/24)"
                      value={newIp}
                      onChange={(e) => handleInputChange(e.target.value)}
                      style={{ flex: 1, borderColor: errorMessage ? "red" : undefined }}
                    />
                    <Button type="primary" onClick={handleAddIp} disabled={!isValidInput}>
                      Add
                    </Button>
                  </div>
                  {errorMessage && <Text type="danger">{errorMessage}</Text>}

                  {/* API error alert above submit */}
                  {apiError && (
                    <Alert message={apiError} type="error" showIcon className="mb-3" />
                  )}

                  <div style={{ marginTop: "20px", textAlign: "center" }}>
                    <Button
                      type="primary"
                      size="large"
                      onClick={handleSubmitIps}
                      disabled={ipList.length === 0 || errorMessage !== ""}
                    >
                      Submit All IPs
                    </Button>
                  </div>
                </Col>
              </Row>
            </Card>
          ) : (
            <p>No company data available.</p>
          )}
        </Content>
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};

export default SubscriptionInfo;
